<template lang="pug">
v-chip(size='small' variant='flat') {{ normalizeTokenForDisplayInChip(token) }}
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-unused-vars*/

defineProps<{ token: string }>();

function normalizeTokenForDisplayInChip(token: string): string {
    return token.replace(/[_-]/g, ' ');
}
</script>
